const $ = require('jquery')

// =========================================================================
// scroll to hotel-rating
// =========================================================================
export const ratingScroll = function() {
  const headerH = $('.header').outerHeight()
  $('.hotel-opinions').click(function() {
    $('html, body').animate({
      scrollTop: $('#scroll-rating').offset().top - headerH,
    }, 1000)
  })
}



// WEBPACK FOOTER //
// ./src/modules/ratingScroll.js